import Vue from 'vue'
import Router from 'vue-router'

const originalPush = Router.prototype.push
// 修改 原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
    path: '/',
    redirect: {
      name: 'login'
    },
  },
  {
    path: '/login',
    name: 'login',
    component: resolve => require(['@/view/login'], resolve),
  },
  {
    path: '/register',
    name: 'register',
    component: resolve => require(['@/view/register'], resolve),
  },
  {
    path: '/password',
    name: 'password',
    component: resolve => require(['@/view/password'], resolve),
  },
  {
    path: '/MemberCenter', //会员中心
    name: 'MemberCenter',
    component: resolve => require(['@/view/MemberCenter'], resolve),
  },
  {
    path: '/interaction', //互动版块
    name: 'interaction',
    component: resolve => require(['@/view/interaction'], resolve),
  },
  {
    path: '/PointsMall', //积分商场
    name: 'PointsMall',
    component: resolve => require(['@/view/PointsMall'], resolve),
  },
  {
    path: '/MemberShip',
    name: 'MemberShip',
    component: resolve => require(['@/view/MemberShip'], resolve),
  },
  {
    path: '/Company',
    name: 'Company',
    component: resolve => require(['@/view/Company'], resolve),
  },
  {
    path: '/personal',
    name: 'personal',
    component: resolve => require(['@/view/personal'], resolve),
  },
  {
    path: '/information',
    name: 'information',
    component: resolve => require(['@/view/information'], resolve),
  },
  {
    path: '/JobHunting',
    name: 'JobHunting',
    component: resolve => require(['@/view/JobHunting'], resolve),
  },
  {
    path: '/Notice',
    name: 'Notice',
    component: resolve => require(['@/view/Notice'], resolve),
  },
  {
    path: '/NoticeContent',
    name: 'NoticeContent',
    component: resolve => require(['@/view/NoticeContent'], resolve),
  },
  {
    path: '/Statement',
    name: 'Statement',
    component: resolve => require(['@/view/Statement'], resolve),
  },
  {
    path: '/rhxz',
    name: 'rhxz',
    component: resolve => require(['@/view/rhxz'], resolve),
  },
  {
    path: '/bill',
    name: 'bill',
    component: resolve => require(['@/view/bill'], resolve),
  },
  {
    path: '/list',
    name: 'list',
    component: resolve => require(['@/view/list'], resolve),
  },
  {
    path: '/Content',
    name: 'Content',
    component: resolve => require(['@/view/audit/Content'], resolve),
    redirect: {
      name: 'UnderReview'
    },
    children: [{
      path: '/Pay',
      name: 'Pay',
      component: resolve => require(['@/view/audit/Pay'], resolve),
    },
    {
      path: '/Member',
      name: 'Member',
      component: resolve => require(['@/view/audit/Member'], resolve),
    },
    ]
  },
  // 手机端
  {
    path: '/home',
    name: 'home',
    component: resolve => require(['@/view/mobile/home'], resolve),
  },
  {
    path: '/MobileMemberShip',
    name: 'MobileMemberShip',
    component: resolve => require(['@/view/mobile/MobileMemberShip'], resolve),
  },
  {
    path: '/MobileCompany',
    name: 'MobileCompany',
    component: resolve => require(['@/view/mobile/MobileCompany'], resolve),
  },
  {
    path: '/MobileRegister',
    name: 'MobileRegister',
    component: resolve => require(['@/view/mobile/MobileRegister'], resolve),
  },
  {
    path: '/MobilePay',
    name: 'MobilePay',
    component: resolve => require(['@/view/mobile/MobilePay'], resolve),
  },
  {
    path: '/MobileMember',
    name: 'MobileMember',
    component: resolve => require(['@/view/mobile/MobileMember'], resolve),
  },
  {
    path: '/MobilePersonal',
    name: 'MobilePersonal',
    component: resolve => require(['@/view/homepage/MobilePersonal'], resolve),
  },
  {
    path: '/MobileInformation',
    name: 'MobileInformation',
    component: resolve => require(['@/view/homepage/MobileInformation'], resolve),
  },
  {
    path: '/MobileJobHunting',
    name: 'MobileJobHunting',
    component: resolve => require(['@/view/homepage/MobileJobHunting'], resolve),
  },
  {
    path: '/MobileJobHuntingList',
    name: 'MobileJobHuntingList',
    component: resolve => require(['@/view/homepage/MobileJobHuntingList'], resolve),
  },
  {
    path: '/MobileNotice',
    name: 'MobileNotice',
    component: resolve => require(['@/view/homepage/MobileNotice'], resolve),
  },
  {
    path: '/MobileNoticeContent',
    name: 'MobileNoticeContent',
    component: resolve => require(['@/view/homepage/MobileNoticeContent'], resolve),
  },
  {
    path: '/MobileBill',
    name: 'MobileBill',
    component: resolve => require(['@/view/homepage/MobileBill'], resolve),
  },
  {
    path: '/MobileCustomerService',
    name: 'MobileCustomerService',
    component: resolve => require(['@/view/homepage/MobileCustomerService'], resolve),
  },
  {
            path: '/PhoneMemberCenter',   //会员中心
            name: 'PhoneMemberCenter',
            component: (resolve) => require(['@/view/homepage/PhoneMemberCenter'], resolve)
        },
        {
            path: '/PhoneIntegralStore',  //积分商城
            name: 'PhoneIntegralStore',
            component: (resolve) => require(['@/view/homepage/PhoneIntegralStore'], resolve)
        },
        {
            path: '/MembershipTicket',  //会费票据
            name: 'MembershipTicket',
            component: (resolve) => require(['@/view/homepage/MembershipTicket'], resolve)
        },
        {
            path: '/ApplyForBill',   //发票提交
            name: 'ApplyForBill',
            component: (resolve) => require(['@/view/homepage/ApplyForBill'], resolve)
        },
        {
            path: '/ExchangeDetails',  //兑换详情
            name: 'ExchangeDetails',
            component: (resolve) => require(['@/view/homepage/ExchangeDetails'], resolve)
        },
        {
            path: '/InteractiveSection',  //互动投稿
            name: 'InteractiveSection',
            component: (resolve) => require(['@/view/homepage/InteractiveSection.vue'], resolve)
        },
  // 后台
  {
    path: '/index',
    name: 'index',
    component: resolve => require(['@/view/index'], resolve),
    redirect: {
      name: 'Homepage'
    },
    children: [{
      path: '/Homepage', //首页总览
      name: 'Homepage',
      component: resolve => require(['@/view/Homepage'], resolve)
    },
    { //社群服务
      path: '/community',
      name: 'community',
      component: resolve => require(['@/view/community'], resolve),
    },
    // // 积分商城
    // {
    //   path: '/pointsShop',
    //   name: 'pointsShop',
    //   component: resolve => require(['@/view/pointsShop'], resolve),
    //   children: [
    //     { //积分商城
    //       path: 'Points_MallView',
    //       name: 'Points_MallView',
    //       component: resolve => require(['@/view/Points_MallView'], resolve),
    //     },
    //     { //订单
    //       path: 'OrderInfo',
    //       name: 'OrderInfo',
    //       component: resolve => require(['@/view/OrderInfo'], resolve),
    //     },
    //   ]
    // },
    // { // 活动管理
    //   path: '/EventPage',
    //   name: 'EventPage',
    //   component: resolve => require(['@/view/EventPage'], resolve),
    //   children: [
    //     { //活动管理
    //       path: 'EventManagement',
    //       name: 'EventManagement',
    //       component: resolve => require(['@/view/EventManagement'], resolve),
    //     },
    //     
    //   ]
    // },
    { //发布活动
      path: '/LaunchEvent',
      name: 'LaunchEvent',
      component: resolve => require(['@/view/LaunchEvent'], resolve),
    },
    { // 活动管理
      path: '/EventManagement',
      name: 'EventManagement',
      component: resolve => require(['@/view/EventManagement'], resolve),
    },
    { //积分商城
      path: '/Points_MallView',
      name: 'Points_MallView',
      component: resolve => require(['@/view/Points_MallView'], resolve),
    },
    { //订单
      path: '/OrderInfo',
      name: 'OrderInfo',
      component: resolve => require(['@/view/OrderInfo'], resolve),
    },
    { //订单
      path: '/JobApplication',
      name: 'JobApplication',
      component: resolve => require(['@/view/JobApplication'], resolve),
    },
    { //会费票据
      path: '/Membershipfee',
      name: 'Membershipfee',
      component: resolve => require(['@/view/Membershipfee'], resolve),
    },
    // 会员中心
    {
      path: '/MemberCenterPage',
      name: 'MemberCenterPage',
      component: resolve => require(['@/view/MemberCenterPage'], resolve),
      meta: {
        isTopLevel: true,
        index: 'MemberCenterPage'
      },
      children: [
        {
          path: '/MemberDetails', //会员详情
          name: 'MemberDetails',
          component: resolve => require(['@/view/MemberDetails'], resolve)
        },
      ]
    },
    // 会员互动/建议
    { //
      path: '/MemberSuggestion',
      name: 'MemberSuggestion',
      component: resolve => require(['@/view/MemberSuggestion'], resolve),
    },
    { //
      path: '/MaterialSubmission',
      name: 'MaterialSubmission',
      component: resolve => require(['@/view/MaterialSubmission'], resolve),
    },
    {
      path: '/EventDetails', //活动详情
      name: 'EventDetails',
      component: resolve => require(['@/view/EventDetails'], resolve)
    },

    ]
  },
  { //后台登录页
    path: '/manage',
    name: 'manage',
    component: resolve => require(['@/view/manage'], resolve),
  },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js